import stringify from 'fast-safe-stringify'
import { getReadableTextColor, hexColorForString } from '@/shared/utils/color'

const isElectron = !!window.electronAPI

export function log(...args: unknown[]) {
  window.fathomLogger?.log(...args)
}

function safeStringify(value: unknown): string {
  return stringify(
    value,
    (_key: string, val: unknown) => {
      if (val instanceof Error) {
        return { name: val.name, message: val.message, stack: val.stack }
      }
      return val
    },
    undefined,
    { depthLimit: 3, edgesLimit: 50 },
  )
}

export function logWithBadge(label: string, message: string, ...args: unknown[]) {
  if (import.meta.env.DEV || !isElectron) {
    const badgeColor = hexColorForString(label)
    const textColor = getReadableTextColor(badgeColor)
    log(
      `%c${label}`,
      `background: ${badgeColor}; color: ${textColor}; padding: .3em 1ch; border-radius: .3em`,
      window.location.href,
      message,
      ...args,
    )
  } else {
    // In Electron (where most of these logs will be showing) we need to tamp down on the output:  it will not stringify
    // objects itself.
    log(`[${label}]`, message, safeStringify(args))
  }
}
